export default {
  login: {
    login: 'Sign in',
    account: 'account',
    password: 'password',
    remember: 'remember',
    forget: 'forget',
    privacy_policy: 'Privacy Policy',
    title: 'STAY admin login page'
  },
  lang: {
    ko: '한국인',
    ja: '日本語',
    zh: '中文(简)',
    'zh-Hant': '中文(繁)',
    en: 'English'
  },
  tip: {
    emptyData: 'No data available',
    login: 'account and password cannot be empty',
    success: 'successful operation',
    fail: 'operation failed',
    tip: 'hint',
    logout: 'Are you sure you want to log out?',
    yes: 'yes',
    no: 'no'
  },
  date: {
    week: {
      0: 'Sun',
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat'
    }
  },
  header: {
    areaGuide: 'Area Guide',
    modelCourses: 'Model Courses',
    travelGuide: 'Travel Guide',
    tickets: 'Tickets',
    areaGuideDescription: 'Every area has its own story to tell',
    modelCoursesDescription: 'Curated itineraries for every travel style',
    travelGuideDescription: 'Real experiences from visitors',
    accessMap: 'Access Map',
    accessMapDescription: 'How to get here from major cities',
    accessMapTitle: 'Main cities access',
    accessCities: {
      tokyo: {
        name: 'From Tokyo',
        description: 'JR・Kintetsu Limited Express',
        time: 'About 3 hours'
      },
      kyoto: {
        name: 'From Kyoto',
        description: 'Kintetsu Limited Express',
        time: 'About 2.5 hours'
      },
      osaka: {
        name: 'From Osaka',
        description: 'Kintetsu Limited Express',
        time: 'About 2 hours'
      },
      nagoya: {
        name: 'From Nagoya',
        description: 'Kintetsu Limited Express',
        time: 'About 1.5 hours'
      }
    }
  },
  footer: {
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    specifiedCommercialTransactions: 'Specified Commercial Transactions Act',
    contact: 'Contact',
    address: '1-2-3 Toba, Toba City, Mie Prefecture 517-0011',
    copyright: '© Kintetsu Railway'
  },
  article: {
    aboutTheCourse: 'About the Course',
    author: 'AUTHOR',
    schedule: 'Schedule',
    recommendedPoints: 'Recommended Points',
    home: 'Home',
    regionalIntroduction: 'Regional Introduction',
    iseCity: 'Ise City',
    iseshi: 'Iseshi',
    iseDescription:
      'A historic town that flourished around Ise Jingu, the heart of the Japanese people.',
    travelGuide: 'Travel Guide',
    iseSightseeingGourmetGuide: 'Ise Sightseeing Gourmet Guide',
    mustSeeSpots: 'Must-See Spots',
    relatedArticles: 'Related Articles',
    touristGuide: 'Tourist Guide',
    basicGuideToVisitingIseJingu: 'Basic Guide to Visiting Ise Jingu',
    traveler: 'Traveler',
    showMore: 'Show more'
  },
  home: {
    learnMore: 'Learn More'
  },
  share: {
    activityCategory: {
      RAILWAY_TICKET: 'Railway Ticket',
      AIRPORT_TRANSPORTATION: 'Airport Transportation',
      SHINKANSEN: 'Shinkansen',
      EXPRESS_BUS: 'Express Bus',
      BUS_TOUR: 'Bus Tour',
      CRUISES: 'Cruises',
      RENTAL_CAR: 'Rental Car',
      CHARTER: 'Charter',
      ATTRACTION: 'Attraction',
      THEME_PARK: 'Theme Park',
      MUSEUM_GALLERY: 'Museum / Gallery',
      AQUARIUM_ZOO: 'Aquarium / Zoo',
      TEMPLES_SHINES: 'Temples / Shrines',
      TOWER_BUILDING: 'Tower / Building',
      JAPANESE_RESTAURANT: 'Japanese Restaurant',
      WESTERN_RESTAURANT: 'Western Restaurant',
      CHINESE_RESTAURANT: 'Chinese Restaurant',
      OTHER_RESTAURANT: 'Other Restaurant',
      DESSERT_BEVERAGE: 'Dessert / Beverage',
      SIGHTSEEING_TOUR: 'Sightseeing Tour',
      MARINE_SPORTS: 'Marine Sports',
      OUTDOOR_ACTIVITIES: 'Outdoor Activities',
      ONSEN: 'Onsen',
      SPA_MASSAGE: 'Spa / Massage',
      JAPANESE_CULTURAL_EXPERIENCE: 'Japanese Cultural Experience',
      JAPANESE_CRAFT_EXPERIENCE: 'Japanese Craft Experience',
      JAPANESE_COOKING_EXPERIENCE: 'Japanese Cooking Experience',
      OTHER_EXPERIENCE: 'Other Experience',
      HOTEL: 'Hotel',
      RYOKAN: 'Ryokan',
      VACATION_RENTAL: 'Vacation Rental',
      BUNDLE: 'Bundle',
      PASS: 'Pass',
      OTHERS: 'Others'
    }
  }
};
